import { createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "autoplay"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["music", [!_ctx.isPlaying && 'paused']]),
    onTouchstart: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchMusic && _ctx.switchMusic(...args)), ["stop"])),
    onMousedown: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchMusic && _ctx.switchMusic(...args)), ["stop"]))
  }, [
    _createElementVNode("audio", {
      id: "audio",
      ref: "audioDom",
      onPlay: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPlaying = true)),
      onPause: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPlaying = false)),
      src: _ctx.musicUrl,
      loop: "",
      autoplay: !_ctx.musicPaused
    }, null, 40, _hoisted_1)
  ], 34)), [
    [_vShow, _ctx.activityData]
  ])
}